import { mapState } from 'vuex';
import UpsertDashboardDialog from './components/upsertDashboardDialog.vue';
export default {
  name: 'ViewDashboardsList',
  components: {
    UpsertDashboardDialog
  },
  data() {
    return {
      showCreateDialog: false,
      accountFilterIsReady: false,
      selectedAccountIds: []
    };
  },
  computed: {
    ...mapState('app', ['permissions']),
    tableHeaders() {
      return [{
        value: 'meta.name',
        text: this.$i18n_t('Dashboards.listView.table.headers.name')
      }];
    },
    hasEditPermissions() {
      return this.permissions['Dashboards.manage'];
    }
  },
  methods: {
    async fetchDashboards(options) {
      if (!options) {
        return {
          items: [],
          total: -1
        };
      }
      const {
        page,
        perPage,
        selectedAccountIds,
        search
      } = options;
      const response = await this.$store.dispatch('dashboards/refresh', {
        selectedAccountIds,
        page: page,
        limit: perPage,
        search
      });
      return {
        items: response.dashboards,
        total: response.total
      };
    },
    onSave(dashboard) {
      this.$router.push(`/dashboards/${dashboard.id}`);
    },
    async deleteDashboard(dashboard) {
      const {
        success,
        error
      } = await this.$store.dispatch('dashboards/deleteById', dashboard.id);
      if (!success) {
        throw error;
      }
    },
    onAccountFilterChange(accounts) {
      this.selectedAccountIds = accounts.map(account => account.id);
    }
  }
};